import { REQUIRED_DOCUMENTS_ICONS } from '../../constants';

export const RequiredDocuments = () => {
  return (
    <div className="my-14 mx-16 sm:my-8 sm:mx-6">
      <div className="text-s-28 font-semibold mb-3 sm:text-s-20 sm:font-medium sm:mb-2">
        How to file Income Tax Returns (ITR) on Cleartax?
      </div>
      <div className="text-base font-semibold mb-6 sm:text-s-14">
        Income Tax e-Filing Guide for FY 2023-2024
      </div>
      <p className="text-base font-normal text-grey-700 mb-2 sm:text-s-12">
        You can now file your income taxes in a jiffy using Cleartax!
        Here&apos;s a step by step guide to file your ITR for{' '}
        <span className="whitespace-nowrap text-base sm:text-s-12">
          FY 2023-2024
        </span>
      </p>
      <p className="text-base font-normal text-grey-700 mb-2 sm:text-s-12">
        We recommend you to keep the following documents handy to file your
        taxes within minutes:
      </p>
      <p className="text-base font-normal text-grey-700 sm:text-s-12">
        PAN Card, Aadhaar Card, Bank Account Number, Form 16 (Salaried People),
        Other Income (if applicable), Investment Details (if applicable)
      </p>

      <div className="mt-14 bg-[#F8FBFF] px-4 py-6 rounded-xl sm:mt-8 sm:px-5 sm:py-5">
        <div className="text-base font-medium mb-6 sm:text-s-14 sm:font-semibold">
          Keep the following documents handy to complete your filing:
        </div>
        <div className="grid grid-cols-6 gap-4 sm:grid-cols-2">
          {REQUIRED_DOCUMENTS_ICONS?.map((item) => (
            <div key={item.label}>
              <div className="flex items-center justify-center w-full">
                <img src={item.icon} alt="" width={42} height={42} />
              </div>
              <div className="text-s-14 font-semibold mt-3 text-center">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
